import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Skeleton, Select } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { setRelationSizeParam } from 'Actions/explore'
import { updateGraphNodes } from 'Actions/graph'
import { RelationSizeParams } from 'Model'
import { updateRelationSizeByAttribute } from 'Services/GraphUtils'
import WeaverService from 'Services/WeaverService'
import SizeService from 'Services/SizeService'

RelationSizeParamsSelector = ({ graphData, relationSizeParam, setRelationSizeParam, updateGraphNodes, updateConfigNode }) ->

  [isEditing, setIsEditing] = useState(false)
  [loading, setLoading] = useState(true)
  [configNode, setConfigNode] = useState(undefined)
  [attList, setAttList] = useState([])

  useEffect( ->
    ( ->
      cNode = await RelationSizeParams.load()
      setConfigNode(cNode)
      setRelationSizeParam(await cNode.key())
      await getAndSetValidAttKeys()
      setLoading(false)
    )()
    undefined
  , [])

  updateGraphEdgeSizes = (val) ->
    { edges } = graphData
    newEdges = { }
    results = await new Weaver.Query().restrict(_.keys(edges)).withRelations().find()
    results.map((n) ->
      att = n.get(val)
      newEdges[n.id()] = {
        edges[n.id()]...,
        value: att or 1
      }
    )

    newGraphData = {
      edges: newEdges
    }
    updateGraphNodes(newGraphData)

  getAndSetValidAttKeys = ->
    result = await new Weaver.Sparql("""
      SELECT DISTINCT ?key ?datatype WHERE {
        ?node ?key ?val
        FILTER (isLiteral(?val))
        BIND(datatype(?val) AS ?datatype)
      }
    """).find()
    validKeys = result.key.filter((key, i) -> result.datatype[i].id() is 'double')
    setAttList(validKeys)

  save = (val) ->
    try
      await configNode.reset()
      await configNode.update(val)
    catch e
      console.log e
    setIsEditing(false)

  <Skeleton
    active
    paragraph={false}
    loading={loading}
  >
    <Select
      allowClear
      onSelect={(val) ->
        setRelationSizeParam(val)
        updateGraphEdgeSizes(val)
        await save(val) if updateConfigNode
      }
      onClear={(val) ->
        setRelationSizeParam(val)
        updateGraphEdgeSizes(val)
        await save(val) if updateConfigNode
      }
      value={relationSizeParam}
      disabled={!WeaverService.userCanEdit()}
      placeholder="Attribute key to set node sizes by"
      bordered={false}
      style={{ width: '100%' }}
    >
      {
        attList.map((attributeKey) ->
          <Select.Option
            key={attributeKey.id()}
            value={attributeKey.id()}
          >
            { _.startCase(attributeKey.id()) }
          </Select.Option>
        )
      }
    </Select>
  </Skeleton>

export default connect(({ explore, graph }) ->
  {
    relationSizeParam: explore.relationSizeParam
    graphData: graph.graphData
  }
, { setRelationSizeParam, updateGraphNodes })(RelationSizeParamsSelector)

